const ASSET_ROOT = "/marketing/gatiq-rewards";

function SampleQrMark() {
  const size = 29;
  const isFinderCell = (x: number, y: number, left: number, top: number) =>
    x >= left && x < left + 7 && y >= top && y < top + 7 &&
    (x === left || x === left + 6 || y === top || y === top + 6 ||
      (x >= left + 2 && x <= left + 4 && y >= top + 2 && y <= top + 4));
  const cells = Array.from({ length: size * size }, (_, index) => {
    const x = index % size;
    const y = Math.floor(index / size);
    const finder = isFinderCell(x, y, 0, 0) || isFinderCell(x, y, size - 7, 0) || isFinderCell(x, y, 0, size - 7);
    const timing = (x === 6 || y === 6) && (x + y) % 2 === 0;
    const detail = ((x * 17 + y * 29 + x * y * 7 + 13) % 19) < 9;
    return finder || timing || detail ? <rect key={index} x={x} y={y} width="1" height="1" /> : null;
  });

  return <svg className="gq-lp-sample-qr" viewBox={`0 0 ${size} ${size}`} aria-hidden="true" shapeRendering="crispEdges">
    <rect width={size} height={size} fill="#fff" />
    <g fill="#151515">{cells}</g>
  </svg>;
}

export function ScanDemoScreenshot({ alt }: { alt: string }) {
  return (
    <div className="gq-lp-phone-screen is-scan">
      <img src={`${ASSET_ROOT}/zenith-karigar-scan.png`} alt={alt} loading="lazy" />
      <div className="gq-lp-scan-overlay" aria-hidden="true">
        <div className="gq-lp-sample-code">
          <span>SAMPLE PRODUCT · D3</span>
          <SampleQrMark />
          <b>15 QCoin · sample code</b>
        </div>
        <div className="gq-lp-scan-frame"><i /></div>
      </div>
    </div>
  );
}
